/**
 * A small, curated palette rather than raw random RGB (which risks
 * ugly/clashing hues) - a folder's color is picked from this set,
 * deterministically, from its own id. Purely derived, never stored:
 * folders are {id, name, createdAt} server-side (confirmed directly
 * against the real backend, lambda/folders_handler.py) with no color
 * field at all, so this needs no backend change - the same folder
 * always resolves to the same color, stable across reloads, without
 * persisting anything extra.
 */
const PALETTE = [
  { color: "#2450ff", soft: "#e8edff" }, // blue
  { color: "#7c3aed", soft: "#f2e9ff" }, // violet
  { color: "#059669", soft: "#d7f5e9" }, // green
  { color: "#d97706", soft: "#fef0d9" }, // amber
  { color: "#be123c", soft: "#ffe4e6" }, // rose
  { color: "#0891b2", soft: "#e0f7fb" }, // cyan
  { color: "#c026d3", soft: "#fbe6fa" }, // magenta
  { color: "#65a30d", soft: "#ecf7d8" }, // lime
];

/**
 * Deterministic string hash → palette index. Same folder id always
 * resolves to the same entry; different ids spread out across the
 * palette without ever needing to store which one was picked.
 */
export function colorForFolderId(id) {
  if (!id) return null;
  let hash = 0;
  for (const ch of String(id)) {
    hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}